import { forwardRef } from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import FormikForm from 'src/ui-component/FormikFormLibrary';
import { Fields } from 'src/ui-component/FormikFormLibrary/FormikTypes';

interface AdditionalInfoProps {
  formData: {
    hasSecondaryContactInfo: boolean;
      secondaryContactName: string;
      secondaryDepartment: string;
      secondaryAddress: string;
      secondaryEmail: string;
      secondaryPhone: string;
  };
  handleSubmit: (val: any) => void;
  setFieldValue: (field: string, value: any) => void;
  isButtonHide?: boolean;
   isEdit?: boolean;
}

const AdditionalInfo = forwardRef<HTMLDivElement, AdditionalInfoProps>(
  ({ formData, setFieldValue, isButtonHide, handleSubmit}, ref) => {
    const handleFieldChange = (val: any, e: any) => {
      const { name } = e;
      setFieldValue(`${name}`, val);
    };

    const fields: Fields[] = formData.hasSecondaryContactInfo
      ? [
        //.secondaryContactInfo?
          {
            fieldName: 'secondaryContactName',
            initialValue: formData.secondaryContactName || '',
            fieldLabel: 'Name',
            fieldType: 'text',
            dependency: handleFieldChange
          },
          {
            fieldName: 'secondaryDepartment',
            initialValue: formData.secondaryDepartment || '',
            fieldLabel: 'Department',
            fieldType: 'text',
            dependency: handleFieldChange
          },
          {
            fieldName: 'secondaryAddress',
            initialValue: formData.secondaryAddress || '',
            fieldLabel: 'Address',
            fieldType: 'text',
            dependency: handleFieldChange
          },
          {
            fieldName: 'secondaryEmail',
            initialValue: formData.secondaryEmail || '',
            fieldLabel: 'Email',
            fieldType: 'email',
            dependency: handleFieldChange
          },
          {
            fieldName: 'secondaryPhone',
            initialValue: formData.secondaryPhone || '',
            fieldLabel: 'Phone Number',
            fieldType: 'mobile',
            dependency: handleFieldChange
          }
        ]
      : [];

    return (
      <FormikForm
        innerRef={ref}
        allFields={fields}
        formMethod={handleSubmit}
        heading="Additional Information"
        buttonTitle={['Cancel']}
        buttonPlacement="right"
        content={
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.hasSecondaryContactInfo}
                onChange={(e) =>
                  setFieldValue('hasSecondaryContactInfo', e.target.checked)
                }
                name="hasSecondaryContactInfo"
              />
            }
            label="Add secondary contact information"
          />
        }
        isButtonHide={isButtonHide}
      />
    );
  }
);

AdditionalInfo.displayName = 'AdditionalInfo';

export default AdditionalInfo;